// System consts
export const AUTH_TYPE_TOKEN = 'Token';
export const AUTH_TYPE_BASIC = 'Basic';
